import React from 'react'
import Header from '../components/screens/homescreen/header/Header'
import Conversatorio from '../components/screens/homescreen/conversatorio/Conversatorio'
import Purpose from '../components/screens/homescreen/purpose/Purpose'
import InterventionAxes from '../components/screens/homescreen/purpose/InterventionAxes'
import BoletinesTimeline from '../components/screens/homescreen/boletines/BoletinesTimeline'
import NewsletterCTA from '../components/NewsletterCTA'
import AssociationCampaignPopup from '../components/AssociationCampaignPopup'
import '../components/screens/homescreen/home.css'

const HomeScreen = ({ showAssociationCampaignPopup = false }) => {
    return (
        <div className='home-page'>
            <Header />
            <Conversatorio />
            <Purpose />
            <InterventionAxes />
            <BoletinesTimeline />
            <NewsletterCTA />
            {showAssociationCampaignPopup && <AssociationCampaignPopup />}
        </div>
    )
}

export default HomeScreen
